import {isValidPolicyNumberPaperElectronic} from 'ApplicationEntry/models/EnteredPolicyNumber';
import * as A from 'ApplicationEntry/models/ProductsRiders/Accident/GroupAccident';
import * as ErrorMessages from '../../ErrorMessages';
import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import './../ProductRiders.sass';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@material-ui/core';
import States from 'ApplicationEntry/models/States';
import {isNonEmptyString} from 'Core/models/EmptyString';
import PackageSelect from '../PackageSelect';
import {CaseDetails, matchCaseDetailsByType} from 'ApplicationEntry/models/CaseDetails';
import * as BAActions from 'ApplicationEntry/ducks/billingAgent';
import * as AActions from 'ApplicationEntry/ducks/ProductsRiders/accident';
import {NonEmptyString, StringUnion} from 'Core/models/EmptyString';
import useBuildPremiumParameterAutoFill from './useBuildPremiumParameterAutoFill';
import {BillingAgent} from 'ApplicationEntry/models/BillingAgent';
import {ValidGroupCaseDetails} from 'ApplicationEntry/models/GroupCaseDetails';
import {Plan} from 'ApplicationEntry/models/ProductsRiders/PlanModel';
import {getSitusStatefromCaseNumber} from 'ApplicationEntry/ducks/caseDetails';

type AccidentProps = {
  caseDetails: CaseDetails;
  accident: A.GroupAccident;
  situs: StringUnion;
  billingAgent: BillingAgent;
};

const Accident = ({caseDetails, accident, situs, billingAgent}: AccidentProps) => {
  const dispatch = useDispatch();
  const {
    packageName,
    planType,
    plan,
    productType,
    calculatedPremium,
    cwa,
    policyNumber,
    replacement,
    section125,
    baseUnits,
    jStamp,
    continuationOfCoverage,
    returnOfPremium,
    onOffJobAccident,
    onOffJobAccidentInsuredSpouse,
    onOffJobAccidentSickness,
    onOffJobAccidentSicknessInsuredSpouse,
    offJobAccident,
    offJobAccidentSickness,
    hsa,
    coverageTier,
    thirdTier,
    packageList,
    riderAmounts,
    df,
    be,
    berUnits,
    oprUnits,
    accTreatmentUcUnits,
    emerRoomSerUnits,
    outpatientPhyUnits,
    dislocFractureUnits,
    accDeathDisUnits,
    spouse,
    employee,
  } = accident;

  let {billingMode} = billingAgent;
  let {billingCode, situsState, userAuthorizedJStamp} = caseDetails as ValidGroupCaseDetails;
  const [riderLabel, setRiderLabel] = useState<HTMLLabelElement | null>();
  const [planTypeBlurred, setBlurPlanType] = useState(false);
  const [planBlurred, setBlurPlan] = useState(false);
  const [policyNumberBlurred, setPolicyNumberBlurred] = useState(false);
  const [planLabel, setPlanLabel] = useState<HTMLLabelElement | null>();
  const [berLabel, setBerLabel] = useState<HTMLLabelElement | null>();
  const [productTypeBlurred, setBlurProductType] = useState(false);
  const [productTypeLabel, setProductTypeLabel] = useState<HTMLLabelElement | null>();
  const showProductTypeError = productTypeBlurred && productType.key === 'Empty';
  const showPlanTypeError = planTypeBlurred && planType.key === 'Empty';
  const showPlanError = planBlurred && plan.key === 'Empty';
  const showPolicyNumberError = policyNumberBlurred && !isValidPolicyNumberPaperElectronic(policyNumber) && replacement;

  const handleAutoFillPremiumGrpProducts = useBuildPremiumParameterAutoFill();

  return (
    <>
      <div className="product-riders-section__policy-type" id="accident-section">
        <form noValidate autoComplete="off" className="product-riders-section__policy-type__form">
          <div className="product-riders-section__policy-type__form__row">
            <Grid container spacing={4}>
              <Grid item xs={12} md={3}>
                <FormControl
                  error={showProductTypeError}
                  variant="outlined"
                  className="product-riders-section__policy-type__form__row--field"
                >
                  <InputLabel ref={setPlanLabel} id="accident-plan-label">
                    Plan
                  </InputLabel>
                  <Select
                    labelId="accident-label-plan"
                    labelWidth={planLabel?.clientWidth}
                    id="accident-plan"
                    value={plan.key === 'Empty' ? '' : plan.value}
                    onBlur={() => setBlurPlan(true)}
                    onChange={event => {
                      dispatch(AActions.changePlan(event.target.value as string));

                      const caseNumber = matchCaseDetailsByType({
                        Group: groupApp =>
                          groupApp.caseNumber.key === 'Loaded'
                            ? groupApp.caseNumber.Data
                            : groupApp.caseNumber.key === 'UserAssignedCaseNumber'
                            ? groupApp.caseNumber.value
                            : '',
                        _: () => '',
                      })(caseDetails);

                      if (event.target.value === 'GVAP6') {
                        const PlanObj: Plan = {};
                        PlanObj.life70Name = 'GVA6';
                        PlanObj.name = 'GVAP6';
                        dispatch(AActions.getOccClass(caseNumber, PlanObj));
                      }
                      dispatch(AActions.getGroupAccidentPackages(caseNumber, event.target.value as string));
                    }}
                    displayEmpty
                  >
                    {A.plans.map((plan: {name: string; displayName: string}, index: number) => (
                      <MenuItem value={plan.name} key={`accident-product-${plan.name}-${index}`}>
                        {plan.displayName}
                      </MenuItem>
                    ))}
                  </Select>
                  {showProductTypeError && <FormHelperText>{ErrorMessages.REQUIRED_MESSAGE}</FormHelperText>}
                </FormControl>
              </Grid>
            </Grid>

            {plan.key === 'NonEmpty' ? (
              <>
                <Grid container spacing={4}>
                  <Grid item xs={12} md={3}>
                    <PackageSelect
                      packageName={packageName}
                      packageList={packageList}
                      changePackageAction={AActions.changePackage}
                      handlePackageItems={(packageItem: object) => {
                        if (billingMode.value !== '') {
                          handleAutoFillPremiumGrpProducts(
                            productType,
                            packageItem,
                            billingMode,
                            planType,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            plan
                          );
                        } else if (billingCode.value !== '') {
                          handleAutoFillPremiumGrpProducts(
                            productType,
                            packageItem,
                            billingCode,
                            planType,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            plan
                          );
                        }

                        dispatch(AActions.changeCoverageTier(packageItem['coverageTier'] as string));
                        dispatch(AActions.changeThirdTier(packageItem['tier3'] as string));
                        dispatch(AActions.changeHsa(packageItem['hsa'] as string));
                        dispatch(AActions.changeBaseUnits(packageItem['baseUnits'] as string));
                        dispatch(AActions.changeBERVersion(packageItem['ber'] as string));
                        dispatch(AActions.changeOprUnits(packageItem['outpatientPhysicianRider'] as string));
                        dispatch(AActions.changeDFVersion(packageItem['dfVersion'] as string));
                        dispatch(AActions.changeBEVersion(packageItem['beVersion'] as string));
                        dispatch(AActions.changeAccUcUnits(packageItem['accTreatUrgent'] as string));
                        dispatch(AActions.changeAccDeathDisUnits(packageItem['accDeathDismemberment'] as string));
                        dispatch(AActions.changeDislocFracUnits(packageItem['dislocFrac'] as string));
                        dispatch(AActions.changeEmerRoomSerUnits(packageItem['emerRoomSer'] as string));
                        dispatch(AActions.changeOutpatientPhyUnits(packageItem['outPatPhysician'] as string));

                        const offJobAccident = packageItem['offJobAccd'];
                        const offJobAccidentSickness = packageItem['offJobAccdSickness'];
                        const onOffJobAccident = packageItem['onOffJobAccd'];
                        const onOffJobAccidentSickness = packageItem['onOffJobAccdSickness'];
                        const onOffJobAccidentInsuredSpouse = packageItem['onOffJobAccdSpouse'];
                        const onOffJobAccidentSicknessInsuredSpouse = packageItem['onOffJobAccdSicknessSpouse'];
                        const continuationOfCoverage = packageItem['strikeLayoff'];
                        const returnOfPremium = packageItem['returnOfPremium'];

                        const valueFromHot = '0.00';

                        if (returnOfPremium) {
                          dispatch(AActions.changeReturnOfPremium((returnOfPremium === null || returnOfPremium === valueFromHot) ? false : true));
                        } else if (continuationOfCoverage) {
                          dispatch(
                            AActions.changeContinuationOfCoverage((continuationOfCoverage === null || continuationOfCoverage === valueFromHot) ? false : true)
                          );
                        }

                        if (onOffJobAccidentSicknessInsuredSpouse) {
                          dispatch(
                            AActions.changeOnOffJobAccidentSicknessSpouse((
                              onOffJobAccidentSicknessInsuredSpouse === null || onOffJobAccidentSicknessInsuredSpouse === valueFromHot) ? false : true
                            )
                          );
                          dispatch(AActions.changeSpouseDisabilityRider(onOffJobAccidentSicknessInsuredSpouse));
                        }
                        if (onOffJobAccidentSickness) {
                          dispatch(
                            AActions.changeOnOffJobAccidentSickness((onOffJobAccidentSickness === null || onOffJobAccidentSickness === valueFromHot) ? false : true)
                          );
                          dispatch(AActions.changeEmployeeDisabilityRider(onOffJobAccidentSickness));
                        }
                        if (onOffJobAccidentInsuredSpouse) {
                          dispatch(
                            AActions.changeOnOffJobAccidentSpouse((onOffJobAccidentInsuredSpouse === null || onOffJobAccidentInsuredSpouse === valueFromHot) ? false : true)
                          );
                          dispatch(AActions.changeSpouseDisabilityRider(onOffJobAccidentInsuredSpouse));
                        }
                        if (offJobAccidentSickness) {
                          dispatch(
                            AActions.changeOffJobAccidentSickness((offJobAccidentSickness === null || offJobAccidentSickness === valueFromHot) ? false : true)
                          );
                          dispatch(AActions.changeEmployeeDisabilityRider(offJobAccidentSickness));
                        }
                        if (onOffJobAccident) {
                          dispatch(AActions.changeOnOffJobAccident((onOffJobAccident === null || onOffJobAccident === valueFromHot) ? false : true));
                          dispatch(AActions.changeEmployeeDisabilityRider(onOffJobAccident));
                        }
                        if (offJobAccident) {
                          dispatch(AActions.changeOffJobAccident((offJobAccident === null || offJobAccident === valueFromHot) ? false : true));
                          dispatch(AActions.changeEmployeeDisabilityRider(offJobAccident));
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <FormControl variant="outlined" className="product-riders-section__policy-type__form__row--field">
                      <InputLabel
                        id="accident-type-label"
                        className={'product-riders-section__policy-type__form__row--label'}
                      >
                        Base Units
                      </InputLabel>
                      <Select
                        labelId="accident-label-type"
                        id="accident-type"
                        value={baseUnits.key === 'Empty' ? '' : parseFloat(baseUnits.value)}
                        onChange={event => dispatch(AActions.changeBaseUnits(event.target.value as string))}
                        displayEmpty
                        disabled
                      >
                        {A.baseUnits[plan.value].map((baseUnit: number) => (
                          <MenuItem value={baseUnit} key={baseUnit}>
                            {baseUnit}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <FormControl
                      error={showPlanTypeError}
                      variant="outlined"
                      className="product-riders-section__policy-type__form__row--field"
                    >
                      <InputLabel
                        id="accident-plantype-label"
                        className={'product-riders-section__policy-type__form__row--label'}
                      >
                        Plan Type
                      </InputLabel>
                      <Select
                        labelId="accident-label-plantype"
                        id="accident-plan-type"
                        value={planType.key === 'Empty' ? '' : planType.value}
                        onBlur={() => setBlurPlanType(true)}
                        onChange={event => {
                          dispatch(AActions.changePlanType(event.target.value as string));
                          if (billingMode.value !== '') {
                            handleAutoFillPremiumGrpProducts(
                              productType,
                              null,
                              billingMode,
                              NonEmptyString.create(event.target.value as string) as StringUnion,
                              undefined,
                              undefined,
                              undefined,
                              packageList,
                              packageName,
                              plan
                            );
                          } else if (billingCode.value !== '') {
                            handleAutoFillPremiumGrpProducts(
                              productType,
                              null,
                              billingCode,
                              NonEmptyString.create(event.target.value as string) as StringUnion,
                              undefined,
                              undefined,
                              undefined,
                              packageList,
                              packageName,
                              plan
                            );
                          }
                        }}
                      >
                        <MenuItem value="IND">Individual</MenuItem>
                        <MenuItem value="FAMILY">Family</MenuItem>
                        <MenuItem value="INDSPS">Ind+Sp</MenuItem>
                        <MenuItem value="INDCH">Ind+Ch</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="checkedB"
                          color="secondary"
                          id="accident-replacement"
                          checked={replacement}
                          onChange={() => dispatch(AActions.changeReplacement(!replacement))}
                        />
                      }
                      label={<Typography className="case-details-section__checkbox-label">Replacement</Typography>}
                      className="product-riders-section__policy-type__form__row--field"
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      id="accident-policy-number"
                      label="Policy Number"
                      variant="outlined"
                      placeholder="Enter Policy Number"
                      margin="normal"
                      fullWidth
                      error={showPolicyNumberError}
                      helperText={showPolicyNumberError ? ErrorMessages.INVALID_POLICY_NUMBER : ''}
                      className="product-riders-section__policy-type__form__row--field"
                      value={policyNumber.key !== 'ValidPolicyNumber' || !replacement ? '' : policyNumber.value.value}
                      onBlur={() => setPolicyNumberBlurred(true)}
                      onChange={event => dispatch(AActions.changePolicyNumber(event.target.value as string))}
                      disabled={!replacement}
                      inputProps={{
                        maxLength: 10,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      id="accident-premium"
                      label="Premium"
                      variant="outlined"
                      placeholder="Enter Premium"
                      margin="normal"
                      fullWidth
                      className="product-riders-section__policy-type__form__row--field"
                      value={calculatedPremium.value}
                      required={section125}
                      onChange={event => {
                        dispatch(AActions.changePremium(event.target.value as string));
                        dispatch(AActions.changeCalculatedPremium(event.target.value as string));
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      id="accident-cwa"
                      label="CWA"
                      variant="outlined"
                      placeholder="Enter CWA"
                      margin="normal"
                      fullWidth
                      className="product-riders-section__policy-type__form__row--field"
                      value={cwa.value}
                      onChange={event => dispatch(AActions.changeCWA(event.target.value as string))}
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="checkedB"
                          color="secondary"
                          id="accident-j-stamp"
                          checked={jStamp}
                          disabled={!userAuthorizedJStamp}
                          onChange={() => dispatch(AActions.changeJStamp(!jStamp))}
                        />
                      }
                      label={<Typography>J-Stamp</Typography>}
                      className="product-riders-section__policy-type__form__row--field"
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="checkedB"
                          color="secondary"
                          id="accident-section-125"
                          checked={section125}
                          onChange={() => dispatch(AActions.changeSection125(!section125))}
                        />
                      }
                      label={<Typography>Section 125</Typography>}
                      className="product-riders-section__policy-type__form__row--field"
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <FormControl variant="outlined" className="product-riders-section__policy-type__form__row--field">
                      <InputLabel
                        id="accident-situs-label"
                        className={'product-riders-section__policy-type__form__row--label'}
                      >
                        Situs State
                      </InputLabel>
                      <Select
                        labelId="accident-label-situs"
                        id="accident-situs"
                        value={situsState.value || accident.situsState.value}
                        onChange={e => {
                          dispatch(AActions.changeSitusState(e.target.value as string));
                          dispatch(getSitusStatefromCaseNumber(''));
                        }}
                        displayEmpty
                      >
                        {States.map(stateCode => (
                          <MenuItem key={stateCode} value={stateCode}>
                            {stateCode}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  {(plan.value === 'GVAP2' || plan.value === 'GVA2FD') && (
                    <>
                      <Grid item xs={12} md={3}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="checkedB"
                              color="secondary"
                              id="accident-continuation-of-coverage"
                              checked={continuationOfCoverage === null ? false : continuationOfCoverage}
                              disabled
                            />
                          }
                          label={<Typography>Continuation of Coverage</Typography>}
                          className="product-riders-section__policy-type__form__row--field"
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="checkedB"
                              color="secondary"
                              id="accident-return-of-premium"
                              checked={returnOfPremium === null ? false : returnOfPremium}
                              disabled
                            />
                          }
                          label={<Typography>Return of Premium</Typography>}
                          className="product-riders-section__policy-type__form__row--field"
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <FormControl
                          variant="outlined"
                          className="product-riders-section__policy-type__form__row--field"
                        >
                          <InputLabel
                            ref={setRiderLabel}
                            id="accident-opr-label"
                            className={'product-riders-section__policy-type__form__row--label'}
                          >
                            OPR
                          </InputLabel>
                          <Select
                            labelId="accident-label-opr"
                            id="accident-opr"
                            labelWidth={riderLabel?.clientWidth}
                            value={oprUnits.key === 'Empty' || oprUnits.value === null ? '' : oprUnits.value}
                            onChange={event => {
                              dispatch(AActions.changeOprUnits(event.target.value as string));
                            }}
                            disabled
                          >
                            {A.oprUnits[plan.value].map((oprUnit: number) => (
                              <MenuItem value={oprUnit} key={oprUnit}>
                                {oprUnit}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <FormControl
                          variant="outlined"
                          className="product-riders-section__policy-type__form__row--field"
                        >
                          <InputLabel
                            ref={setBerLabel}
                            id="accident-type-label"
                            className={'product-riders-section__policy-type__form__row--label'}
                          >
                            BER
                          </InputLabel>
                          <Select
                            labelId="accident-label-ber"
                            id="accident-ber"
                            labelWidth={riderLabel?.clientWidth}
                            value={berUnits.key === 'Empty' || berUnits.value === null ? '' : berUnits.value}
                            onChange={event => dispatch(AActions.changeBERVersion(event.target.value as string))}
                            displayEmpty
                            disabled
                          >
                            {A.berUnits[plan.value].map((berUnit: number) => (
                              <MenuItem value={berUnit} key={berUnit}>
                                {berUnit}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    </>
                  )}

                  {plan.value === 'GVAP6' && (
                    <>
                      <Grid item xs={12} md={3}>
                        <TextField
                          id="accident-hsa"
                          label="HSA"
                          variant="outlined"
                          placeholder="Enter HSA"
                          margin="normal"
                          fullWidth
                          className="product-riders-section__policy-type__form__row--field"
                          value={hsa.value}
                          onChange={event => dispatch(AActions.changeHsa(event.target.value as string))}
                          disabled
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <TextField
                          id="accident-third-tier"
                          label="3Tier"
                          variant="outlined"
                          placeholder="Enter Three Tier"
                          margin="normal"
                          fullWidth
                          className="product-riders-section__policy-type__form__row--field"
                          value={thirdTier.value}
                          onChange={event => dispatch(AActions.changeThirdTier(event.target.value as string))}
                          disabled
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <FormControl
                          variant="outlined"
                          className="product-riders-section__policy-type__form__row--field"
                        >
                          <InputLabel
                            id="accident-df-label"
                            className={'product-riders-section__policy-type__form__row--label'}
                          >
                            DF
                          </InputLabel>
                          <Select
                            labelId="accident-label-df"
                            id="accident-df"
                            value={df.key === 'Empty' ? '' : df.value}
                            disabled
                          >
                            <MenuItem value={df.value} key={df.value}>
                              {df.value}
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <FormControl
                          variant="outlined"
                          className="product-riders-section__policy-type__form__row--field"
                        >
                          <InputLabel
                            id="accident-be-label"
                            className={'product-riders-section__policy-type__form__row--label'}
                          >
                            BE
                          </InputLabel>
                          <Select
                            labelId="accident-label-be"
                            id="accident-be"
                            value={be.key === 'Empty' ? '' : be.value}
                            disabled
                          >
                            <MenuItem value={be.value} key={be.value}>
                              {be.value}
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <FormControl
                          variant="outlined"
                          className="product-riders-section__policy-type__form__row--field"
                        >
                          <InputLabel
                            id="accident-accident-treatment-urgent-care-label"
                            className={'product-riders-section__policy-type__form__row--label'}
                          >
                            Accident Treatment and Urgent Care
                          </InputLabel>
                          <Select
                            labelId="accident-label-accident-treatment-urgent-care"
                            id="accident-accident-treatment-urgent-care"
                            value={
                              accTreatmentUcUnits.key === 'Empty' || accTreatmentUcUnits.value === null
                                ? ''
                                : parseFloat(accTreatmentUcUnits.value)
                            }
                            onChange={e => dispatch(AActions.changeAccUcUnits(e.target.value as string))}
                            displayEmpty
                            disabled
                          >
                            {A.accTreatmentUcUnits[plan.value]?.map((accTreatmentUcUnit: number) => (
                              <MenuItem value={accTreatmentUcUnit} key={accTreatmentUcUnit}>
                                {accTreatmentUcUnit}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <FormControl
                          variant="outlined"
                          className="product-riders-section__policy-type__form__row--field"
                        >
                          <InputLabel
                            id="accident-emergency-room-services-label"
                            className={'product-riders-section__policy-type__form__row--label'}
                          >
                            Emergency Room Services
                          </InputLabel>
                          <Select
                            labelId="accident-label-emergency-room-services"
                            id="accident-emergency-room-services"
                            value={
                              emerRoomSerUnits.key === 'Empty' || emerRoomSerUnits.value === null
                                ? ''
                                : parseFloat(emerRoomSerUnits.value)
                            }
                            onChange={e => dispatch(AActions.changeEmerRoomSerUnits(e.target.value as string))}
                            displayEmpty
                            disabled
                          >
                            {A.emerRoomSerUnits[plan.value].map((emerRoomSerUnit: number) => (
                              <MenuItem value={emerRoomSerUnit} key={emerRoomSerUnit}>
                                {emerRoomSerUnit}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <FormControl
                          variant="outlined"
                          className="product-riders-section__policy-type__form__row--field"
                        >
                          <InputLabel
                            id="accident-outpatient-physicians-label"
                            className={'product-riders-section__policy-type__form__row--label'}
                          >
                            Outpatient Physicians
                          </InputLabel>
                          <Select
                            labelId="accident-label-outpatient-physicians"
                            id="accident-outpatient-physicians"
                            value={
                              outpatientPhyUnits.key === 'Empty' || outpatientPhyUnits.value === null
                                ? ''
                                : parseFloat(outpatientPhyUnits.value)
                            }
                            onChange={e => dispatch(AActions.changeOutpatientPhyUnits(e.target.value as string))}
                            disabled
                            displayEmpty
                          >
                            {A.outpatientPhyUnits[plan.value].map((outpatientPhyUnit: number) => (
                              <MenuItem value={outpatientPhyUnit} key={outpatientPhyUnit}>
                                {outpatientPhyUnit}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <FormControl
                          variant="outlined"
                          className="product-riders-section__policy-type__form__row--field"
                        >
                          <InputLabel
                            id="accident-dislocation-fracture-label"
                            className={'product-riders-section__policy-type__form__row--label'}
                          >
                            Dislocation/Fracture
                          </InputLabel>
                          <Select
                            labelId="accident-label-dislocation-fracture"
                            id="accident-dislocation-fracture"
                            value={
                              dislocFractureUnits.key === 'Empty' || dislocFractureUnits.value === null
                                ? ''
                                : parseFloat(dislocFractureUnits.value)
                            }
                            onChange={e => dispatch(AActions.changeDislocFracUnits(e.target.value as string))}
                            disabled
                            displayEmpty
                          >
                            {A.dislocFractureUnits[plan.value].map((dislocFracUnit: number) => (
                              <MenuItem value={dislocFracUnit} key={dislocFracUnit}>
                                {dislocFracUnit}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <FormControl
                          variant="outlined"
                          className="product-riders-section__policy-type__form__row--field"
                        >
                          <InputLabel
                            id="accident-accidental-death-dismemberment-functional-loss-label"
                            className={'product-riders-section__policy-type__form__row--label'}
                          >
                            Accidental Death, Dismemberment and Functional Loss
                          </InputLabel>
                          <Select
                            labelId="accident-label-accidental-death-dismemberment-functional-loss"
                            id="accident-accidental-death-dismemberment-functional-loss"
                            value={
                              accDeathDisUnits.key === 'Empty' || accDeathDisUnits.value === null
                                ? ''
                                : parseFloat(accDeathDisUnits.value)
                            }
                            onChange={e => dispatch(AActions.changeAccDeathDisUnits(e.target.value as string))}
                            disabled
                            displayEmpty
                          >
                            {A.accDeathDisUnits[plan.value].map((accDeathDisUnit: number) => (
                              <MenuItem value={accDeathDisUnit} key={accDeathDisUnit}>
                                {accDeathDisUnit}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <FormControl
                          variant="outlined"
                          className="product-riders-section__policy-type__form__row--field"
                        >
                          <InputLabel
                            id="accident-type-label"
                            className={'product-riders-section__policy-type__form__row--label'}
                          >
                            BER
                          </InputLabel>
                          <Select
                            labelId="accident-label-ber"
                            id="accident-ber"
                            value={
                              berUnits.key === 'Empty' || berUnits.value === null ? '' : parseFloat(berUnits.value)
                            }
                            onChange={event => dispatch(AActions.changeBERVersion(event.target.value as string))}
                            displayEmpty
                            disabled
                          >
                            {A.berUnits[plan.value].map((berUnit: number) => (
                              <MenuItem value={berUnit} key={berUnit}>
                                {berUnit}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    </>
                  )}

                  {plan.value === 'GVAP1' && (
                    <>
                      <Grid item xs={12} md={3}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="checkedB"
                              color="secondary"
                              id="accident-off-job-accident"
                              checked={offJobAccident}
                              disabled
                            />
                          }
                          label={<Typography>Off the Job Accident</Typography>}
                          className="product-riders-section__policy-type__form__row--field"
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="checkedB"
                              color="secondary"
                              id="accident-on-off-job-accident-sickness"
                              checked={onOffJobAccidentSickness}
                              disabled
                            />
                          }
                          label={<Typography>On and Off the Job Accident and Sickness</Typography>}
                          className="product-riders-section__policy-type__form__row--field"
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="checkedB"
                              color="secondary"
                              id="accident-on-off-job-accident"
                              checked={onOffJobAccident}
                              disabled
                            />
                          }
                          label={<Typography>On and Off the Job Accident</Typography>}
                          className="product-riders-section__policy-type__form__row--field"
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="checkedB"
                              color="secondary"
                              id="accident-off-job-accident-sickness"
                              checked={offJobAccidentSickness}
                              disabled
                            />
                          }
                          label={<Typography>Off the Job Accident and Sickness</Typography>}
                          className="product-riders-section__policy-type__form__row--field"
                        />
                      </Grid>

                      <Grid item xs={12} md={3}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="checkedB"
                              color="secondary"
                              id="accident-off-job-accident-sickness-insured-spouse"
                              checked={onOffJobAccidentInsuredSpouse}
                              disabled
                            />
                          }
                          label={<Typography>On and Off the Job Accident for Insured Spouse</Typography>}
                          className="product-riders-section__policy-type__form__row--field"
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="checkedB"
                              color="secondary"
                              id="accident-on-off-job-accident-sickness-insured-spouse"
                              checked={onOffJobAccidentSicknessInsuredSpouse}
                              disabled
                            />
                          }
                          label={<Typography>On and Off the Job Accident and Sickness for Insured Spouse</Typography>}
                          className="product-riders-section__policy-type__form__row--field"
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="checkedB"
                              color="secondary"
                              id="accident-continuation-of-coverage"
                              checked={continuationOfCoverage}
                              disabled
                            />
                          }
                          label={<Typography>Continuation of Coverage</Typography>}
                          className="product-riders-section__policy-type__form__row--field"
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="checkedB"
                              color="secondary"
                              id="accident-return-of-premium"
                              checked={returnOfPremium}
                              disabled
                            />
                          }
                          label={<Typography>Return of Premium</Typography>}
                          className="product-riders-section__policy-type__form__row--field"
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <FormControl
                          variant="outlined"
                          className="product-riders-section__policy-type__form__row--field"
                        >
                          <InputLabel ref={setBerLabel} id="accident-ber-label">
                            BER
                          </InputLabel>
                          <Select
                            labelId="accident-label-ber"
                            labelWidth={berLabel?.clientWidth}
                            id="accident-ber"
                            value={(berUnits.key === 'Empty' || berUnits.value === null || berUnits.value === '0.00') ? '' : berUnits.value}
                            onChange={event => {
                              dispatch(AActions.changeBERVersion(event.target.value as string));
                            }}
                            displayEmpty
                            disabled
                          >
                            <MenuItem value="1">1</MenuItem>
                            <MenuItem value="1.00">1</MenuItem>
                            <MenuItem value="1.5">1.5</MenuItem>
                            <MenuItem value="2">2</MenuItem>
                            <MenuItem value="2.00">2</MenuItem>
                            <MenuItem value="2.5">2.5</MenuItem>
                            <MenuItem value="3">3</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      {/* Disability rider units */}
                      <Grid item xs={12} col-md={3}>
                        <FormLabel id="disability-rider-units" padding-block="80px">
                          Disability Rider Units
                        </FormLabel>
                      </Grid>
                      <Grid container spacing={4} className="product-riders-section__policy-type__form">
                        <Grid item xs={12} md={3}>
                          <FormControl
                            variant="outlined"
                            className="product-riders-section__policy-type__form__row--field"
                          >
                            <InputLabel
                              id="accident-employee-label"
                              className={'product-riders-section__policy-type__form__row--label'}
                              padding-block="80px"
                            >
                              Employee
                            </InputLabel>
                            <Select
                              labelId="accident-label-employee"
                              id="accident-employee"
                              value={employee.key === 'Empty' ? '' : parseFloat(employee.value)}
                              onChange={event =>
                                dispatch(AActions.changeEmployeeDisabilityRider(event.target.value as string))
                              }
                              displayEmpty
                              disabled
                            >
                              {A.baseUnits[plan.value].map((baseUnit: number) => (
                                <MenuItem value={baseUnit} key={baseUnit}>
                                  {baseUnit}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} md={3}>
                          <FormControl
                            variant="outlined"
                            className="product-riders-section__policy-type__form__row--field"
                          >
                            <InputLabel
                              id="accident-spouse-label"
                              className={'product-riders-section__policy-type__form__row--label'}
                              padding-block="80px"
                            >
                              Spouse
                            </InputLabel>
                            <Select
                              labelId="accident-label-spouse"
                              id="accident-spouse"
                              value={spouse.key === 'Empty' ? '' : parseFloat(spouse.value)}
                              onChange={event =>
                                dispatch(AActions.changeSpouseDisabilityRider(event.target.value as string))
                              }
                              displayEmpty
                              disabled
                            >
                              {A.baseUnits[plan.value].map((baseUnit: number) => (
                                <MenuItem value={baseUnit} key={baseUnit}>
                                  {baseUnit}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>
                    </>
                  )}

                  {plan.value === 'GVA1FD' && (
                    <>
                      <Grid item xs={12} md={3}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="checkedB"
                              color="secondary"
                              id="accident-off-job-accident"
                              checked={offJobAccident}
                              disabled
                            />
                          }
                          label={<Typography>Off the Job Accident</Typography>}
                          className="product-riders-section__policy-type__form__row--field"
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="checkedB"
                              color="secondary"
                              id="accident-on-off-job-accident"
                              checked={onOffJobAccident}
                              disabled
                            />
                          }
                          label={<Typography>On and Off the Job Accident</Typography>}
                          className="product-riders-section__policy-type__form__row--field"
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="checkedB"
                              color="secondary"
                              id="accident-off-job-accident-sickness"
                              checked={offJobAccidentSickness}
                              disabled
                            />
                          }
                          label={<Typography>Off the Job Accident and Sickness</Typography>}
                          className="product-riders-section__policy-type__form__row--field"
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="checkedB"
                              color="secondary"
                              id="accident-on-off-job-accident-sickness"
                              checked={onOffJobAccidentSickness}
                              disabled
                            />
                          }
                          label={<Typography>On and Off the Job Accident and Sickness</Typography>}
                          className="product-riders-section__policy-type__form__row--field"
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="checkedB"
                              color="secondary"
                              id="accident-off-job-accident-sickness-insured-spouse"
                              checked={onOffJobAccidentInsuredSpouse}
                              disabled
                            />
                          }
                          label={<Typography>On and Off the Job Accident for Insured Spouse</Typography>}
                          className="product-riders-section__policy-type__form__row--field"
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="checkedB"
                              color="secondary"
                              id="accident-on-off-job-accident-sickness-insured-spouse"
                              checked={onOffJobAccidentSicknessInsuredSpouse}
                              disabled
                            />
                          }
                          label={<Typography>On and Off the Job Accident and Sickness for Insured Spouse</Typography>}
                          className="product-riders-section__policy-type__form__row--field"
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="checkedB"
                              color="secondary"
                              id="accident-continuation-of-coverage"
                              checked={continuationOfCoverage === null ? false : continuationOfCoverage}
                              disabled
                            />
                          }
                          label={<Typography>Continuation of Coverage</Typography>}
                          className="product-riders-section__policy-type__form__row--field"
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="checkedB"
                              color="secondary"
                              id="accident-return-of-premium"
                              checked={returnOfPremium === null ? false : returnOfPremium}
                              disabled
                            />
                          }
                          label={<Typography>Return of Premium</Typography>}
                          className="product-riders-section__policy-type__form__row--field"
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <FormControl
                          variant="outlined"
                          className="product-riders-section__policy-type__form__row--field"
                        >
                          <InputLabel ref={setBerLabel} id="accident-ber-label">
                            BER
                          </InputLabel>
                          <Select
                            labelId="accident-label-ber"
                            labelWidth={berLabel?.clientWidth}
                            id="accident-ber"
                            value={berUnits.key === 'Empty' || berUnits.value === null ? '' : berUnits.value}
                            onChange={event => {
                              dispatch(AActions.changeBERVersion(event.target.value as string));
                            }}
                            displayEmpty
                            disabled
                          >
                            <MenuItem value="1">1</MenuItem>
                            <MenuItem value="1.5">1.5</MenuItem>
                            <MenuItem value="2">2</MenuItem>
                            <MenuItem value="2.5">2.5</MenuItem>
                            <MenuItem value="3">3</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      {/* Disability rider units */}
                      <Grid item xs={12} col-md={3}>
                        <FormLabel id="disability-rider-units" padding-block="80px">
                          Disability Rider Units
                        </FormLabel>
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <FormControl
                          variant="outlined"
                          className="product-riders-section__policy-type__form__row--field"
                        >
                          <InputLabel
                            id="accident-employee-label"
                            className={'product-riders-section__policy-type__form__row--label'}
                            padding-block="80px"
                          >
                            Employee
                          </InputLabel>
                          <Select
                            labelId="accident-label-employee"
                            id="accident-employee"
                            value={employee.key === 'Empty' ? '' : parseFloat(employee.value)}
                            onChange={event =>
                              dispatch(AActions.changeEmployeeDisabilityRider(event.target.value as string))
                            }
                            displayEmpty
                            disabled
                          >
                            {A.baseUnits[plan.value].map((baseUnit: number) => (
                              <MenuItem value={baseUnit} key={baseUnit}>
                                {baseUnit}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} col-md={3} />
                      <Grid item xs={12} md={3}>
                        <FormControl
                          variant="outlined"
                          className="product-riders-section__policy-type__form__row--field"
                        >
                          <InputLabel
                            id="accident-spouse-label"
                            className={'product-riders-section__policy-type__form__row--label'}
                            padding-block="80px"
                          >
                            Spouse
                          </InputLabel>
                          <Select
                            labelId="accident-label-spouse"
                            id="accident-spouse"
                            value={spouse.key === 'Empty' ? '' : parseFloat(spouse.value)}
                            onChange={event =>
                              dispatch(AActions.changeSpouseDisabilityRider(event.target.value as string))
                            }
                            displayEmpty
                            disabled
                          >
                            {A.baseUnits[plan.value].map((baseUnit: number) => (
                              <MenuItem value={baseUnit} key={baseUnit}>
                                {baseUnit}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    </>
                  )}
                </Grid>
              </>
            ) : null}
          </div>
        </form>
      </div>
    </>
  );
};

export default Accident;
